<template>
  <span>
    {{ valueFormatted }}
    <b-tooltip v-if="isTruncated" v-bind="tooltipOption" />
  </span>
</template>

<script>
import { useIsTruncated } from '@/composables/UseIsTruncated'

/**
 * ag-grid の cell に省略時のみ ifield-tooltip でツールチップ表示できるテキストを表示するレンダラー
 */
export default {
  name: 'AppTextWithIFieldTooltipCellRenderer',
  setup() {
    const { truncTarget, isTruncated } = useIsTruncated()
    return { truncTarget, isTruncated }
  },
  computed: {
    /**
     * フォーマット済み値
     * @type {string}
     */
    valueFormatted() {
      return this.params.valueFormatted
    },
    /**
     * ツールチップオプション
     * @type {Object}
     */
    tooltipOption() {
      return {
        // 必ず cell の中心基準で表示させるために親のラッパー要素を対象にする
        target: () => this.params.eGridCell,
        interactive: false,
        container: 'body',
        boundary: 'window',
        placement: 'bottom',
        customClass: 'ifield-tooltip',
        title: this.valueFormatted,
      }
    },
  },
  mounted() {
    // 自身の span 要素は overflow するコンテンツ要素なので省略を見るには親のラッパー要素を見る
    this.truncTarget = this.params.eGridCell
  },
}
</script>
